/** Base-ui Select may invoke `onValueChange` with a string or single-element array depending on wiring. */
export function selectNextString(nextValue: string | string[]): string {
  return Array.isArray(nextValue) ? (nextValue[0] ?? "") : nextValue
}
